export enum Events {
	// receive
	DO_LOGOUT = 'DO_LOGOUT',
	INIT_FORGE_DATA = 'INIT_FORGE_DATA',
	INIT_EXTEND_SESSION = 'INIT_EXTEND_SESSION',

	// propagate
	PROPAGATE_FORGE_TOKEN_UPDATED = 'PROPAGATE_FORGE_TOKEN_UPDATED',
	PROPAGATE_LOGOUT = 'PROPAGATE_LOGOUT', // TODO: Implement listener in the Provider
	PROPAGATE_SESSION_FINISH_TIME = 'PROPAGATE_SESSION_FINISH_TIME',
	PROPAGATE_SHOW_MODAL = 'PROPAGATE_SHOW_MODAL',
	PROPAGATE_SESSION_EXPIRED = 'PROPAGATE_SESSION_EXPIRED',
	WORKER_ERROR = 'WORKER_ERROR',
	PING = 'PING',
	PONG = 'PONG',
}
